const compareBuild = require('./compare-build')
const sort = (list, loose) => list.sort((a, b) => compareBuild(a, b, loose))
module.exports = sort



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/functions/sort.js
// module id = 1420
// module chunks = 0